import { useState, useEffect } from 'react';

/**
 * Debounced text input for TanStack Table global filter.
 *
 * @param {string}   value       Controlled value
 * @param {Function} onChange    Called after debounce with new string
 * @param {string}   placeholder Input placeholder
 */
export default function TextFilter( {
	value,
	onChange,
	placeholder = 'Buscar...',
} ) {
	const [ local, setLocal ] = useState( value );

	useEffect( () => {
		const t = setTimeout( () => onChange( local ), 300 );
		return () => clearTimeout( t );
	}, [ local ] );

	// Sync external resets (e.g. clearing the filter programmatically)
	useEffect( () => {
		setLocal( value );
	}, [ value ] );

	return (
		<input
			type="text"
			value={ local }
			onChange={ ( e ) => setLocal( e.target.value ) }
			placeholder={ placeholder }
			className={ `w-full max-w-[12rem] px-3 py-2 border-2 border-black rounded-none shadow-sm focus:outline-none focus:border-blue ${
				local ? 'bg-white' : 'bg-gray-light'
			}` }
		/>
	);
}
